/* CHIARO · Arma tu pulsera — configurador de pulsera italiana (base + charms en los eslabones). Se inicializa en cada .chiaro-bb-sec */
(function () {
  function init(root) {
  var SID = root.id.replace(/^shopify-section-/, '');
  if (root.__chBBDone) return;
  root.__chBBDone = true;
  var dataEl = root.querySelector('[data-ch-bb-data]');
  var mount = root.querySelector('[data-ch-bb-app]');
  var wrap = root.querySelector('.ch-bb');
  if (!dataEl || !mount) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  window.__chBB = window.__chBB || {};
  if (window.__chBB[SID] && window.__chBB[SID].destroy) window.__chBB[SID].destroy();

  var cfg = D.cfg, L = cfg.labels || {};
  var LA = 1.147; /* link aspect (w/h) */
  var clean = function (a) { return (a || []).filter(Boolean); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var lower = function (arr) { return (arr || []).map(function (t) { return String(t).toLowerCase().trim(); }); };

  function money(cents) {
    var f = cfg.moneyFormat || ('$' + '{{amount}}');
    var v = (cents || 0) / 100;
    function sep(num, th, dec, d) {
      var s = num.toFixed(d);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return d ? parts[0] + dec + parts[1] : parts[0];
    }
    var out = f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      switch (k) {
        case 'amount': return sep(v, ',', '.', 2);
        case 'amount_no_decimals': return sep(v, ',', '.', 0);
        case 'amount_with_comma_separator': return sep(v, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(v, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return sep(v, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return sep(v, ' ', ',', 0);
        case 'amount_with_space_separator': return sep(v, ' ', ',', 2);
        case 'amount_with_period_and_space_separator': return sep(v, ' ', '.', 2);
        default: return sep(v, ',', '.', 2);
      }
    });
    return out.replace(/<[^>]*>/g, '');
  }

  function metalOf(tags, title) {
    var t = tags.join(' ') + ' ' + String(title || '').toLowerCase();
    if (/two-?tone|bicolor|bi-color/.test(t)) return 'twotone';
    if (/\bgold\b|gold-tone|\[g\]/.test(t)) return 'gold';
    if (/\bsilver\b|silver-tone|steel|\[s\]/.test(t)) return 'silver';
    return '';
  }
  function kindOf(type, tags) {
    var t = String(type || '').toLowerCase();
    var all = t + ' ' + tags.join(' ');
    if (/safety chain|span:2/.test(all)) return 'chain';
    if (/dangle|hanging|pendant|colgante/.test(all)) return 'dangle';
    return 'charm';
  }
  var DEF_FIT = {
    charm: { x: 0.1143, y: 0.163, w: 0.7715, h: 0.6728, r: 1 },
    dangle: { x: 0.31, y: 0.117, w: 0.38, h: 0.32, r: 1 },
    chain: { x: 0.1, y: 0.16, w: 0.8, h: 0.32, r: 1 }
  };
  var stripRe = null;
  (function () {
    var words = String(cfg.stripWords || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (!words.length) return;
    var escRe = function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    stripRe = new RegExp('\\s*\\b(?:' + words.map(escRe).join('|') + ')s?\\b', 'gi');
  })();
  function displayName(t) {
    var out = String(t || '');
    if (cfg.hideMetalSuffix) out = out.replace(/\s*[\[(](?:g|s|gold|silver|two-?tone)[\])]/gi, '');
    if (stripRe) out = out.replace(stripRe, '');
    out = out.replace(/\s{2,}/g, ' ').replace(/^[\s\-–·,]+|[\s\-–·,]+$/g, '').trim();
    return out || t;
  }
  function norm(p) {
    var tags = lower(p.tags);
    var kind = kindOf(p.type, tags);
    var slotsTag = tags.filter(function (t) { return /^slots:\d+$/.test(t); })[0];
    return {
      id: p.id, vid: p.vid, t: p.t || '', dt: displayName(p.t || ''), h: p.h, u: p.u, p: Number(p.p) || 0, pf: p.pf || money(p.p), cp: Number(p.cp) || 0, cpf: p.cpf || null,
      img: p.img, tags: tags, type: p.type || '', av: p.av !== false, q: (p.q == null ? null : Number(p.q)),
      metal: metalOf(tags, p.t), kind: kind, span: kind === 'chain' ? 2 : 1,
      slots: slotsTag ? parseInt(slotsTag.split(':')[1], 10) : (cfg.slots || 18),
      search: (p.t || '').toLowerCase() + ' ' + tags.join(' ')
    };
  }
  var bases = clean(D.bases).map(norm);
  var charms = clean(D.charms).map(norm);
  if (cfg.danglesLast) {
    var rank = { charm: 0, dangle: 1, chain: 2 };
    charms = charms.map(function (c, i) { return [c, i]; }).sort(function (a, b) { return (rank[a[0].kind] - rank[b[0].kind]) || (a[1] - b[1]); }).map(function (x) { return x[0]; });
  }
  var cats = clean(D.cats).map(function (c) {
    return { id: c.id, label: c.label || '', tags: lower(String(c.tags || '').split(',')).filter(Boolean) };
  }).filter(function (c) { return c.label && c.tags.length; });

  /* ---------- state ---------- */
  var st = { base: null, placed: [], sel: null, cat: 'all', q: '', metal: false, shown: cfg.perPage || 36, uid: 0, baseOpen: true };
  var fitCache = {};

  /* ---------- image fit (measure link box on canvas) ---------- */
  function measure(url) {
    if (!url) return Promise.resolve(null);
    if (fitCache[url]) return fitCache[url];
    var pr = new Promise(function (res) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { var f = null; try { f = computeFit(im); } catch (e) { f = null; } res(f); };
      im.onerror = function () { res(null); };
      im.src = url;
    });
    fitCache[url] = pr;
    return pr;
  }
  function computeFit(im) {
    var S = 96, c = document.createElement('canvas');
    c.width = S; c.height = S;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(im, 0, 0, S, S);
    var d = g.getImageData(0, 0, S, S).data;
    var rows = [], y, x, i;
    for (y = 0; y < S; y++) {
      var xmin = -1, xmax = -1;
      for (x = 0; x < S; x++) {
        i = (y * S + x) * 4;
        if (d[i + 3] < 24) continue;
        if (Math.min(d[i], d[i + 1], d[i + 2]) >= 238) continue;
        if (xmin < 0) xmin = x;
        xmax = x;
      }
      rows.push(xmin < 0 ? null : [xmin, xmax]);
    }
    var top = -1, bot = -1;
    for (y = 0; y < S; y++) { if (rows[y] && rows[y][1] - rows[y][0] >= 4) { if (top < 0) top = y; bot = y; } }
    if (top < 0) return null;
    var maxw = 0, end = bot, Lx = S, Rx = -1;
    for (y = top; y <= bot; y++) {
      var r = rows[y], w = r ? (r[1] - r[0] + 1) : 0;
      if (y - top >= 4 && w < 0.55 * maxw) { end = y - 1; break; }
      if (w > maxw) maxw = w;
      if (r) { if (r[0] < Lx) Lx = r[0]; if (r[1] > Rx) Rx = r[1]; }
    }
    if (Rx < Lx) return null;
    var fit = { x: Lx / S, y: top / S, w: (Rx - Lx + 1) / S, h: (end - top + 1) / S, r: (im.naturalHeight || 1) / (im.naturalWidth || 1) };
    if (fit.w < 0.08 || fit.h < 0.05) return null;
    return fit;
  }
  function applyFit(img, fit, span) {
    var A = LA * (span || 1);
    var w = fit.w, x = fit.x, y = fit.y, h = fit.h, r = fit.r || 1;
    img.style.width = (100 / w) + '%';
    img.style.left = (-100 * x / w) + '%';
    img.style.top = 'calc(50% - ' + ((y + h / 2) * (r / w) * A * 100) + '%)';
  }
  function fitImage(img, url, kind, span) {
    applyFit(img, DEF_FIT[kind] || DEF_FIT.charm, span);
    measure(url).then(function (f) {
      if (f && img.isConnected && img.getAttribute('src') === url) applyFit(img, f, span);
    });
  }

  /* ---------- DOM build ---------- */
  mount.innerHTML =
    '<div class="ch-bb__layout">' +
      '<div class="ch-bb__main">' +
        '<section class="ch-bb__block ch-bb__block--bases" data-bases-block>' +
          '<div class="ch-bb__step"><h3>' + esc(L.step1) + '</h3></div>' +
          '<div class="ch-bb__bases" data-bases></div>' +
        '</section>' +
        '<div class="ch-bb__sticky' + (cfg.stickyStrip ? ' is-sticky' : '') + '" data-sticky>' +
          '<div class="ch-bb__chosen" data-chosen></div>' +
          '<div class="ch-bb__strip-wrap" data-strip-wrap>' +
            '<div class="ch-bb__strip" data-strip><div class="ch-bb__links" data-links role="list"></div></div>' +
            '<div class="ch-bb__strip-foot"><span data-filled></span><span class="ch-bb__scroll-hint">' + esc(L.scrollHint) + '</span></div>' +
          '</div>' +
        '</div>' +
        '<section class="ch-bb__block ch-bb__block--charms">' +
          '<div class="ch-bb__step"><h3>' + esc(L.step2) + '</h3><small>' + esc(L.hint) + '</small></div>' +
          '<div class="ch-bb__tools">' +
            (cfg.showSearch ? '<label class="ch-bb__search"><span class="ch-bb__sr">' + esc(L.search) + '</span><input type="search" data-search placeholder="' + esc(L.search) + '" autocomplete="off"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.8-3.8"/></svg></label>' : '') +
            (cfg.showMetal ? '<label class="ch-bb__toggle"><input type="checkbox" data-metal><span>' + esc(L.metal) + '</span></label>' : '') +
          '</div>' +
          '<div class="ch-bb__cats" data-cats role="group"></div>' +
          '<div class="ch-bb__grid" data-grid></div>' +
          '<div class="ch-bb__more" data-more></div>' +
        '</section>' +
      '</div>' +
      '<aside class="ch-bb__aside" data-aside>' +
        '<div class="ch-bb__card">' +
          '<h3>' + esc(L.summary) + '</h3>' +
          '<div class="ch-bb__row"><span>' + esc(L.base) + '</span><span data-sum-base>—</span></div>' +
          '<div class="ch-bb__row"><span>' + esc(L.charms) + ' <span data-sum-count>0</span></span><span data-sum-charms>' + esc(money(0)) + '</span></div>' +
          '<div class="ch-bb__row ch-bb__row--total"><span>' + esc(L.total) + '</span><strong data-sum-total>' + esc(money(0)) + '</strong></div>' +
          '<div class="ch-bb__actions">' +
            '<button type="button" class="ch-btn ch-btn--wide" data-add>' + esc(L.add) + '</button>' +
            '<button type="button" class="ch-btn ch-btn--link" data-clear>' + esc(L.clear) + '</button>' +
          '</div>' +
          '<p class="ch-bb__msg" data-msg role="status" aria-live="polite"></p>' +
        '</div>' +
        '<div class="ch-bb__bar">' +
          '<div class="ch-bb__bar-msg" data-msg-m role="status" aria-live="polite"></div>' +
          '<div class="ch-bb__bar-info"><span class="ch-bb__bar-total" data-sum-total-m>' + esc(money(0)) + '</span><span class="ch-bb__bar-sub" data-sum-sub-m></span></div>' +
          '<div style="display:flex;align-items:center;gap:1.4rem"><button type="button" class="ch-btn ch-btn--link" data-clear-m>' + esc(L.clear) + '</button><button type="button" class="ch-btn" data-add-m>' + esc(L.add) + '</button></div>' +
        '</div>' +
      '</aside>' +
    '</div>';

  var $ = function (sel) { return mount.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(mount.querySelectorAll(sel)); };
  var elBases = $('[data-bases]'), elBasesBlock = $('[data-bases-block]'), elChosen = $('[data-chosen]'), elSticky = $('[data-sticky]'),
      elStripWrap = $('[data-strip-wrap]'), elStrip = $('[data-strip]'), elLinks = $('[data-links]'),
      elFilled = $('[data-filled]'), elCats = $('[data-cats]'), elGrid = $('[data-grid]'), elMore = $('[data-more]'),
      elSearch = $('[data-search]'), elMetal = $('[data-metal]'), elMsg = $('[data-msg]'), elMsgM = $('[data-msg-m]');

  /* ---------- messages ---------- */
  var msgTimer = null;
  function msg(text, kind, sticky) {
    [elMsg, elMsgM].forEach(function (el) {
      if (!el) return;
      el.textContent = text || '';
      el.classList.remove('is-error', 'is-ok');
      if (kind) el.classList.add('is-' + kind);
    });
    clearTimeout(msgTimer);
    if (text && !sticky) msgTimer = setTimeout(function () { msg(''); }, 3500);
  }

  /* ---------- helpers ---------- */
  function slotsCount() { return st.base ? st.base.slots : (cfg.slots || 18); }
  function occupancy() {
    var occ = {};
    st.placed.forEach(function (it) { for (var k = 0; k < it.span; k++) occ[it.slot + k] = it; });
    return occ;
  }
  function firstFree(span) {
    var n = slotsCount(), occ = occupancy();
    for (var i = 0; i + span <= n; i++) {
      var ok = true;
      for (var k = 0; k < span; k++) { if (occ[i + k]) { ok = false; break; } }
      if (ok) return i;
    }
    return -1;
  }
  function nearestFree(target, span, ignoreUid) {
    var n = slotsCount(), occ = occupancy();
    var free = function (i) {
      if (i < 0 || i + span > n) return false;
      for (var k = 0; k < span; k++) { var o = occ[i + k]; if (o && o.uid !== ignoreUid) return false; }
      return true;
    };
    if (free(target)) return target;
    for (var d = 1; d < n; d++) {
      if (free(target - d)) return target - d;
      if (free(target + d)) return target + d;
    }
    return -1;
  }
  function countOf(pid) { return st.placed.filter(function (it) { return it.id === pid; }).length; }
  function canAddMore(c) { return c.q == null || countOf(c.id) < c.q; }
  function byUid(uid) { return st.placed.filter(function (it) { return it.uid === uid; })[0]; }

  /* ---------- render: bases ---------- */
  function priceHtml(x, cls) {
    if (!cfg.showPrices) return '';
    var sale = !!(x.cpf && x.cp > x.p);
    return '<span class="' + cls + (sale ? ' is-sale' : '') + '">' +
      (sale ? '<s class="ch-bb__compare">' + esc(x.cpf) + '</s> ' : '') +
      '<span class="ch-bb__now">' + esc(x.pf) + '</span></span>';
  }
  function renderBases() {
    if (!bases.length) {
      elBases.innerHTML = '<p class="ch-bb__empty">' + esc(L.noBase) + '</p>';
      return;
    }
    elBases.innerHTML = bases.map(function (b) {
      return '<button type="button" class="ch-bb__base" data-base="' + b.id + '" aria-pressed="' + (st.base && st.base.id === b.id ? 'true' : 'false') + '">' +
        '<span class="ch-bb__base-media">' + (b.img ? '<img src="' + esc(b.img) + '" alt="' + esc(b.dt) + '" loading="lazy" draggable="false">' : '') + '</span>' +
        '<span class="ch-bb__base-name">' + esc(b.dt) + '</span>' +
        priceHtml(b, 'ch-bb__base-price') +
        '</button>';
    }).join('');
  }
  function markBase() {
    $$('[data-base]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', st.base && String(st.base.id) === btn.getAttribute('data-base') ? 'true' : 'false');
    });
  }
  function renderChosen() {
    if (!elChosen) return;
    if (st.base) {
      elChosen.innerHTML =
        (st.base.img ? '<img class="ch-bb__chosen-thumb" src="' + esc(st.base.img) + '" alt="" draggable="false">' : '') +
        '<span class="ch-bb__chosen-name">' + esc(st.base.dt) + '</span>' +
        (cfg.showPrices ? '<span class="ch-bb__chosen-price">' + esc(st.base.pf) + '</span>' : '') +
        '<button type="button" class="ch-btn ch-btn--link" data-change>' + esc(L.change) + '</button>';
    } else {
      elChosen.innerHTML = '<span class="ch-bb__chosen-empty">' + esc(L.pickBase) + '</span>' +
        (bases.length ? '<button type="button" class="ch-btn ch-btn--link" data-change>' + esc(L.choose) + '</button>' : '');
    }
  }
  function setBaseOpen(open, scroll) {
    st.baseOpen = !!open;
    if (elBasesBlock) { if (st.baseOpen) elBasesBlock.removeAttribute('hidden'); else elBasesBlock.setAttribute('hidden', ''); }
    if (st.baseOpen && scroll && elBasesBlock) {
      var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var y = elBasesBlock.getBoundingClientRect().top + window.pageYOffset - hh - 16;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    }
  }
  function selectBase(b, keepOpen) {
    if (st.base && b && st.base.id === b.id) { if (!keepOpen) setBaseOpen(false); renderChosen(); return; }
    st.base = b;
    st.sel = null;
    if (b) {
      /* keep charms that still fit */
      st.placed = st.placed.filter(function (it) { return it.slot + it.span <= b.slots; });
      measure(tileFor(b));
    }
    markBase();
    renderChosen();
    if (b && !keepOpen) setBaseOpen(false);
    renderStrip();
    renderSummary();
    renderGrid();
  }

  /* ---------- render: strip ---------- */
  function tileFor(base) {
    var t = cfg.tiles || {};
    var m = base ? base.metal : '';
    return t[m] || (m === 'twotone' ? (t.silver || t.gold) : (t.silver || t.gold)) || '';
  }
  function renderStrip() {
    var n = slotsCount();
    elLinks.style.setProperty('--n', n);
    var occ = occupancy();
    var html = '', i = 0, hasHang = false;
    var tile = st.base ? tileFor(st.base) : '';
    while (i < n) {
      var it = occ[i];
      if (it && it.slot === i) {
        if (it.kind !== 'charm') hasHang = true;
        html += '<button type="button" class="ch-bb__slot is-filled' + (it.span > 1 ? ' span-2' : '') + (st.sel === it.uid ? ' is-selected' : '') + '" data-i="' + i + '" data-uid="' + it.uid + '" role="listitem" aria-label="' + esc((i + 1) + ': ' + it.t) + '">' +
          '<img class="ch-bb__slot-img" src="' + esc(it.img) + '" alt="" draggable="false" data-kind="' + it.kind + '" data-span="' + it.span + '">' +
          '<span class="ch-bb__slot-x" data-x title="' + esc(L.remove) + '">&times;</span>' +
          '</button>';
        i += it.span;
      } else {
        if (!st.base) {
          html += '<span class="ch-bb__slot is-empty is-placeholder" data-i="' + i + '" role="listitem" aria-hidden="true"></span>';
        } else if (tile) {
          html += '<button type="button" class="ch-bb__slot is-empty" data-i="' + i + '" role="listitem" aria-label="' + esc('Link ' + (i + 1)) + '"><img class="ch-bb__slot-img is-tile" src="' + esc(tile) + '" alt="" draggable="false" data-kind="charm" data-span="1"></button>';
        } else {
          html += '<button type="button" class="ch-bb__slot is-empty" data-i="' + i + '" role="listitem" aria-label="' + esc('Link ' + (i + 1)) + '"><span class="ch-bb__slot-tile ch-bb__slot-tile--' + (st.base.metal || 'silver') + '"></span></button>';
        }
        i += 1;
      }
    }
    elLinks.innerHTML = html;
    elStrip.classList.toggle('has-hang', hasHang);
    $$('.ch-bb__slot-img').forEach(function (img) {
      fitImage(img, img.getAttribute('src'), img.getAttribute('data-kind'), parseInt(img.getAttribute('data-span'), 10) || 1);
    });
    var used = st.placed.reduce(function (a, it) { return a + it.span; }, 0);
    elFilled.textContent = st.base ? (L.filled || '').replace('{used}', used).replace('{total}', n) : '';
    requestAnimationFrame(syncStrip);
  }
  function syncStrip() {
    var slot = elLinks.querySelector('.ch-bb__slot');
    if (slot) elStrip.style.setProperty('--bb-slot-h', slot.getBoundingClientRect().height + 'px');
    elStripWrap.classList.toggle('can-scroll', elStrip.scrollWidth > elStrip.clientWidth + 2);
  }

  /* ---------- render: categories + grid ---------- */
  function catCount(c) {
    return charms.filter(function (x) { return (!cfg.hideSoldOut || x.av) && x.tags.some(function (t) { return c.tags.indexOf(t) !== -1; }); }).length;
  }
  function renderCats() {
    var html = '<button type="button" class="ch-bb__cat" data-cat="all" aria-pressed="' + (st.cat === 'all') + '">' + esc(L.all) + '</button>';
    var shown = 0;
    cats.forEach(function (c) {
      if (catCount(c) === 0 && st.cat !== c.id) return; /* hide empty categories (they appear as soon as a charm carries the tag) */
      shown++;
      html += '<button type="button" class="ch-bb__cat" data-cat="' + esc(c.id) + '" aria-pressed="' + (st.cat === c.id) + '">' + esc(c.label) + '</button>';
    });
    elCats.innerHTML = shown ? html : '';
  }
  function markCat() {
    $$('[data-cat]').forEach(function (btn) { btn.setAttribute('aria-pressed', btn.getAttribute('data-cat') === st.cat ? 'true' : 'false'); });
  }
  function refreshMaxed() {
    $$('[data-charm]').forEach(function (btn) {
      var c = charms.filter(function (x) { return String(x.id) === btn.getAttribute('data-charm'); })[0];
      var maxed = c ? !canAddMore(c) : false;
      btn.classList.toggle('is-maxed', maxed);
      if (maxed) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    });
  }
  function visibleCharms() {
    var cat = cats.filter(function (c) { return c.id === st.cat; })[0];
    var q = st.q.trim().toLowerCase();
    var bm = st.base ? st.base.metal : '';
    return charms.filter(function (c) {
      if (cfg.hideSoldOut && !c.av) return false;
      if (cat && !c.tags.some(function (t) { return cat.tags.indexOf(t) !== -1; })) return false;
      if (q && c.search.indexOf(q) === -1) return false;
      if (st.metal && bm && bm !== 'twotone' && c.metal && c.metal !== bm) return false;
      return true;
    });
  }
  function renderGrid() {
    var list = visibleCharms();
    if (!charms.length) { elGrid.innerHTML = '<p class="ch-bb__empty">' + esc(L.empty) + '</p>'; elMore.innerHTML = ''; return; }
    if (!list.length) { elGrid.innerHTML = '<p class="ch-bb__empty">' + esc(L.empty) + '</p>'; elMore.innerHTML = ''; return; }
    var shown = list.slice(0, st.shown);
    elGrid.innerHTML = shown.map(function (c) {
      var maxed = !canAddMore(c);
      return '<button type="button" class="ch-bb__charm' + (maxed ? ' is-maxed' : '') + '" data-charm="' + c.id + '" aria-label="' + esc(c.dt + (cfg.showPrices ? ', ' + c.pf : '')) + '"' + (maxed ? ' aria-disabled="true"' : '') + '>' +
        '<span class="ch-bb__charm-media">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" loading="lazy" draggable="false">' : '') + '</span>' +
        (c.kind === 'dangle' && L.dangle ? '<span class="ch-bb__charm-badge">' + esc(L.dangle) + '</span>' : '') +
        (c.kind === 'chain' && L.chain ? '<span class="ch-bb__charm-badge">' + esc(L.chain) + '</span>' : '') +
        '<span class="ch-bb__charm-plus" aria-hidden="true">+</span>' +
        '<span class="ch-bb__charm-name">' + esc(c.dt) + '</span>' +
        priceHtml(c, 'ch-bb__charm-price') +
        '</button>';
    }).join('');
    elMore.innerHTML = list.length > shown.length ? '<button type="button" class="ch-btn ch-btn--ghost" data-show-more>' + esc(L.more) + ' (' + (list.length - shown.length) + ')</button>' : '';
  }

  /* ---------- render: summary ---------- */
  function renderSummary() {
    var charmsTotal = st.placed.reduce(function (a, it) { return a + it.p; }, 0);
    var total = (st.base ? st.base.p : 0) + charmsTotal;
    var count = st.placed.length;
    var set = function (sel, v) { var el = $(sel); if (el) el.textContent = v; };
    set('[data-sum-base]', st.base ? (st.base.dt + (cfg.showPrices ? ' · ' + st.base.pf : '')) : '—');
    set('[data-sum-count]', '× ' + count);
    set('[data-sum-charms]', money(charmsTotal));
    set('[data-sum-total]', money(total));
    set('[data-sum-total-m]', money(total));
    set('[data-sum-sub-m]', st.base ? (st.base.dt + ' · ' + count + ' ' + (L.charms || '').toLowerCase()) : (L.pickBase || ''));
    ['[data-add]', '[data-add-m]'].forEach(function (sel) { var b = $(sel); if (b) b.disabled = !st.base; });
  }

  /* ---------- actions ---------- */
  function placeCharm(c, slot) {
    if (!st.base) { msg(L.pickBase, 'error'); return false; }
    if (!canAddMore(c)) { msg((L.maxed || '').replace('{n}', c.q), 'error'); return false; }
    var target = slot == null ? firstFree(c.span) : nearestFree(slot, c.span);
    if (target < 0) { msg(L.full, 'error'); return false; }
    st.placed.push({ uid: ++st.uid, id: c.id, vid: c.vid, t: c.dt, p: c.p, pf: c.pf, img: c.img, kind: c.kind, span: c.span, slot: target });
    st.sel = null;
    renderStrip(); renderSummary(); refreshMaxed();
    return true;
  }
  function removeUid(uid) {
    st.placed = st.placed.filter(function (it) { return it.uid !== uid; });
    if (st.sel === uid) st.sel = null;
    renderStrip(); renderSummary(); refreshMaxed();
  }
  function moveUid(uid, target) {
    var it = byUid(uid);
    if (!it) return false;
    var n = slotsCount();
    if (target < 0) target = 0;
    if (target + it.span > n) target = n - it.span;
    if (target === it.slot) return true;
    var occ = occupancy();
    var blockers = [];
    for (var k = 0; k < it.span; k++) { var o = occ[target + k]; if (o && o.uid !== uid && blockers.indexOf(o) === -1) blockers.push(o); }
    if (!blockers.length) { it.slot = target; }
    else if (blockers.length === 1 && blockers[0].span === it.span) {
      /* swap with the single occupant of the same size */
      var other = blockers[0];
      other.slot = it.slot; it.slot = target;
    } else {
      msg(L.taken, 'error');
      return false;
    }
    renderStrip(); renderSummary();
    return true;
  }
  function clearAll() {
    st.placed = []; st.sel = null;
    renderStrip(); renderSummary(); refreshMaxed(); msg('');
  }
  function buildItems() {
    var layout = st.placed.slice().sort(function (a, b) { return a.slot - b.slot; }).map(function (it) {
      return (it.slot + 1) + (it.span > 1 ? '-' + (it.slot + it.span) : '') + ' ' + it.t;
    }).join(' · ');
    var items = [{ id: st.base.vid, quantity: 1, properties: {} }];
    items[0].properties[L.propLayout || 'Charm layout'] = layout || '—';
    var agg = {};
    st.placed.slice().sort(function (a, b) { return a.slot - b.slot; }).forEach(function (it) {
      if (!agg[it.vid]) agg[it.vid] = { id: it.vid, quantity: 0, slots: [] };
      agg[it.vid].quantity += 1;
      agg[it.vid].slots.push(it.span > 1 ? (it.slot + 1) + '-' + (it.slot + it.span) : String(it.slot + 1));
    });
    Object.keys(agg).forEach(function (k) {
      var a = agg[k], props = {};
      props[L.propLink || 'Link'] = a.slots.join(', ');
      items.push({ id: a.id, quantity: a.quantity, properties: props });
    });
    return items;
  }
  var adding = false;
  function addToCart() {
    if (!st.base) { msg(L.pickBase, 'error'); return; }
    if (adding) return;
    adding = true;
    msg(L.adding, null, true);
    ['[data-add]', '[data-add-m]'].forEach(function (sel) { var b = $(sel); if (b) b.disabled = true; });
    var done = function (ok, text) {
      adding = false;
      if (!ok) { msg(text || L.error, 'error', true); ['[data-add]', '[data-add-m]'].forEach(function (sel) { var b = $(sel); if (b) b.disabled = false; }); return; }
      msg(L.added, 'ok', true);
      if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl || '/cart'; return; }
      refreshCart();
      ['[data-add]', '[data-add-m]'].forEach(function (sel) { var b = $(sel); if (b) b.disabled = false; });
    };
    fetch(cfg.cartAddUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: buildItems() }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: r.ok, j: null }; }); })
      .then(function (res) {
        if (!res.ok) { done(false, (res.j && (res.j.description || res.j.message)) || L.error); return; }
        done(true);
      })
      .catch(function () { done(false); });
  }
  function refreshCart() {
    try {
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var inner = tmp.querySelector('#cart-icon-bubble');
            bubble.innerHTML = inner ? inner.innerHTML : html;
          }
          if (typeof window.publish === 'function') { try { window.publish('cart-update', { source: 'chiaro-builder' }); } catch (e) {} }
        }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- events ---------- */
  var onDocMove = null, onDocUp = null;
  mount.addEventListener('click', function (e) {
    var t = e.target;
    var baseBtn = t.closest('[data-base]');
    if (baseBtn) { var b = bases.filter(function (x) { return String(x.id) === baseBtn.getAttribute('data-base'); })[0]; selectBase(b); return; }
    if (t.closest('[data-change]')) { setBaseOpen(true, true); return; }
    var catBtn = t.closest('[data-cat]');
    if (catBtn) { st.cat = catBtn.getAttribute('data-cat'); st.shown = cfg.perPage || 36; markCat(); renderGrid(); return; }
    if (t.closest('[data-show-more]')) { st.shown += (cfg.perPage || 36); renderGrid(); return; }
    if (t.closest('[data-add]') || t.closest('[data-add-m]')) { addToCart(); return; }
    if (t.closest('[data-clear]') || t.closest('[data-clear-m]')) { clearAll(); return; }
    var charmBtn = t.closest('[data-charm]');
    if (charmBtn) {
      if (suppressClick) { suppressClick = false; return; }
      var c = charms.filter(function (x) { return String(x.id) === charmBtn.getAttribute('data-charm'); })[0];
      if (c) placeCharm(c, null);
      return;
    }
    var xBtn = t.closest('[data-x]');
    if (xBtn) { var sl = xBtn.closest('.ch-bb__slot'); if (sl) removeUid(parseInt(sl.getAttribute('data-uid'), 10)); e.stopPropagation(); return; }
    var slot = t.closest('.ch-bb__slot');
    if (slot) {
      if (suppressClick) { suppressClick = false; return; }
      var i = parseInt(slot.getAttribute('data-i'), 10);
      if (slot.classList.contains('is-filled')) {
        var uid = parseInt(slot.getAttribute('data-uid'), 10);
        if (st.sel && st.sel !== uid) { var mv = byUid(st.sel); if (mv && moveUid(st.sel, i)) { st.sel = null; renderStrip(); return; } }
        st.sel = (st.sel === uid) ? null : uid;
        renderStrip();
        if (st.sel) msg(L.moveHint);
      } else if (st.sel) {
        if (moveUid(st.sel, i)) { st.sel = null; renderStrip(); msg(''); }
      }
      return;
    }
  });
  if (elSearch) elSearch.addEventListener('input', function () { st.q = elSearch.value; st.shown = cfg.perPage || 36; renderGrid(); });
  if (elMetal) elMetal.addEventListener('change', function () { st.metal = elMetal.checked; st.shown = cfg.perPage || 36; renderGrid(); });
  mount.addEventListener('keydown', function (e) {
    if ((e.key === 'Delete' || e.key === 'Backspace') && st.sel && !/input|textarea/i.test(e.target.tagName)) { e.preventDefault(); removeUid(st.sel); }
    if (e.key === 'Escape' && st.sel) { st.sel = null; renderStrip(); msg(''); }
  });

  /* pointer drag (mouse / pen): from grid or from a filled slot */
  var suppressClick = false;
  mount.addEventListener('pointerdown', function (e) {
    if (e.button !== 0 || e.pointerType === 'touch') return;
    if (onDocMove) { document.removeEventListener('pointermove', onDocMove); document.removeEventListener('pointerup', onDocUp); document.removeEventListener('pointercancel', onDocUp); onDocMove = onDocUp = null; }
    var src = e.target.closest('[data-charm], .ch-bb__slot.is-filled');
    if (!src || e.target.closest('[data-x]')) return;
    var charm = null, uid = null;
    if (src.hasAttribute('data-charm')) {
      charm = charms.filter(function (x) { return String(x.id) === src.getAttribute('data-charm'); })[0];
      if (!charm || !st.base || !canAddMore(charm)) return;
    } else {
      uid = parseInt(src.getAttribute('data-uid'), 10);
    }
    var sx = e.clientX, sy = e.clientY, dragging = false, ghost = null, over = null;
    var imgUrl = charm ? charm.img : (byUid(uid) || {}).img;
    var span = charm ? charm.span : (byUid(uid) || {}).span || 1;
    var clearOver = function () { if (over) { over.classList.remove('is-over'); over = null; } };
    var slotAt = function (x, y) {
      if (ghost) ghost.style.display = 'none';
      var el = document.elementFromPoint(x, y);
      if (ghost) ghost.style.display = '';
      var s = el && el.closest ? el.closest('.ch-bb__slot') : null;
      if (s && !elLinks.contains(s)) s = null;
      if (!s && el && elStrip.contains(el)) {
        /* over the strip but between/outside slots: pick by x */
        var r = elLinks.getBoundingClientRect(), n = slotsCount();
        var idx = Math.floor((x - r.left) / r.width * n);
        if (idx < 0) idx = 0; if (idx > n - 1) idx = n - 1;
        s = elLinks.querySelector('.ch-bb__slot[data-i="' + idx + '"]') || null;
        if (!s) { var occ = occupancy(); var o = occ[idx]; if (o) s = elLinks.querySelector('.ch-bb__slot[data-uid="' + o.uid + '"]'); }
      }
      return s;
    };
    onDocMove = function (ev) {
      if (!dragging) {
        if (Math.abs(ev.clientX - sx) < 6 && Math.abs(ev.clientY - sy) < 6) return;
        dragging = true;
        wrap.classList.add('is-dragging');
        if (uid != null) { var se = elLinks.querySelector('.ch-bb__slot[data-uid="' + uid + '"]'); if (se) se.classList.add('is-ghosted'); }
        ghost = document.createElement('img');
        ghost.className = 'ch-bb__ghost';
        ghost.src = imgUrl || '';
        ghost.alt = '';
        ghost.setAttribute('style', 'position:fixed;z-index:9999;width:60px;height:60px;object-fit:contain;pointer-events:none;opacity:.92;border-radius:6px;box-shadow:0 4px 14px rgba(0,0,0,.25);background:#fff;transform:translate(-50%,-50%);left:' + ev.clientX + 'px;top:' + ev.clientY + 'px;');
        document.body.appendChild(ghost);
      }
      ghost.style.left = ev.clientX + 'px';
      ghost.style.top = ev.clientY + 'px';
      var s = slotAt(ev.clientX, ev.clientY);
      if (s !== over) { clearOver(); if (s) { over = s; s.classList.add('is-over'); } }
      ev.preventDefault();
    };
    onDocUp = function (ev) {
      document.removeEventListener('pointermove', onDocMove);
      document.removeEventListener('pointerup', onDocUp);
      document.removeEventListener('pointercancel', onDocUp);
      onDocMove = onDocUp = null;
      if (!dragging) return;
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);
      wrap.classList.remove('is-dragging');
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      var target = slotAt(ev.clientX, ev.clientY);
      clearOver();
      $$('.is-ghosted').forEach(function (el) { el.classList.remove('is-ghosted'); });
      if (!target) { renderStrip(); return; }
      var ti = parseInt(target.getAttribute('data-i'), 10);
      if (charm) {
        /* dropped on an occupied link -> nearest free link */
        placeCharm(charm, ti);
      } else if (uid != null) {
        moveUid(uid, ti);
        st.sel = null; renderStrip();
      }
    };
    document.addEventListener('pointermove', onDocMove);
    document.addEventListener('pointerup', onDocUp);
    document.addEventListener('pointercancel', onDocUp);
  });
  mount.addEventListener('dragstart', function (e) { e.preventDefault(); });

  var ro = null;
  if ('ResizeObserver' in window) { ro = new ResizeObserver(function () { syncStrip(); }); ro.observe(elStrip); }
  else window.addEventListener('resize', syncStrip);

  /* ---------- extra pages (Section Rendering API) ---------- */
  var pages = parseInt(cfg.pages, 10) || 1;
  if (pages > 1 && typeof fetch === 'function') {
    var pending = [];
    for (var p = 2; p <= pages && p <= 12; p++) {
      (function (pg) {
        var u = window.location.pathname + '?section_id=' + encodeURIComponent(SID) + '&page=' + pg;
        pending.push(fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var d = tmp.querySelector('[data-ch-bb-data]');
          if (!d) return;
          var j = JSON.parse(d.textContent);
          clean(j.charms).map(norm).forEach(function (c) { if (!charms.some(function (x) { return x.id === c.id; })) charms.push(c); });
        }).catch(function () {}));
      })(p);
    }
    Promise.all(pending).then(function () { renderCats(); renderGrid(); });
  }

  /* ---------- init ---------- */
  try {
    var qcat = new URLSearchParams(window.location.search).get('cat');
    if (qcat) {
      qcat = qcat.toLowerCase().trim();
      var hit = cats.filter(function (c) { return c.label.toLowerCase() === qcat || c.id === qcat || c.tags.indexOf(qcat) !== -1; })[0];
      if (hit) st.cat = hit.id;
    }
  } catch (e) {}
  renderBases();
  renderCats();
  renderChosen();
  if (cfg.preselect && bases.length) selectBase(bases[0]); else { setBaseOpen(true); renderStrip(); renderSummary(); renderGrid(); }
  /* warm up tiles */
  Object.keys(cfg.tiles || {}).forEach(function (k) { if (cfg.tiles[k]) measure(cfg.tiles[k]); });

  window.__chBB[SID] = {
    destroy: function () {
      if (onDocMove) document.removeEventListener('pointermove', onDocMove);
      if (onDocUp) { document.removeEventListener('pointerup', onDocUp); document.removeEventListener('pointercancel', onDocUp); }
      if (ro) ro.disconnect(); else window.removeEventListener('resize', syncStrip);
    },
    state: st
  };
  }
  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.chiaro-bb-sec'), function (root) { try { init(root); } catch (e) { if (window.console) console.error('chiaro-bracelet-builder', e); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('.chiaro-bb-sec') : null;
    if (!root && e.detail && e.detail.sectionId) root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (root && root.classList.contains('chiaro-bb-sec')) { root.__chBBDone = false; try { init(root); } catch (err) {} }
  });
})();
